
          var isMobile = window.matchMedia("only screen and (max-width: 769px)");
          var barPosition;
          var country;
          var mha_device = 'desktop';
          if (isMobile.matches) {
            mha_device = 'mobile';
          }
          $(document).on('keyup', '#mhaDaoBarEmail', function(event) {
            if (event.keyCode === 13) {
              $('#mhaDaoBarSubscribe').click();
            }
          });
          $.getJSON("https://freegeoip.net/json/", function (data) {
            country = data.country_name;
            if (window.masterapp.customer){
              var mha_email = window.masterapp.customer.email;
            }else{
              var mha_email = '';
            }
            $.ajax({
              url: 'https://dev-masterapp.hulkapps.com/dao_bar/frontend/get_dao_bar_initial_html',
              type: 'GET',
              data: {shop_id: window.masterapp.store_id,device: mha_device,country: country,email: mha_email,page: window.location.href,cart_total: window.masterapp.cart.total_price}
            })
            .done(function(data) {
              console.log('dattaaaaaaaa------>',data);
              barPosition = data.position;
              setTimeout(function(){
                if (data.dao_bar_html) {
                  if(data.bar_type == 'timer'){
                    $.getScript('https://dev-masterapp.hulkapps.com/plugin_js/lodash.min.js', function () {
                      $.getScript('https://dev-masterapp.hulkapps.com/plugin_js/jquery.countdown.js', function () {
                        console.log('timer') 
                        $('#mhaDaoBar').html(data.dao_bar_html);
                        $('#mhaDaoBar').addClass('timer-wrapper');
                        setBody();
                      });
                    });
                  }
                  else if(data.bar_type == 'announcement'){
                    $.getScript('https://dev-masterapp.hulkapps.com/plugin_js/jquery.bxslider.js', function () {
                      $('#mhaDaoBar').html(data.dao_bar_html);
                      $('.bxslider').bxSlider({
                        mode: 'fade',
                        controls: false,
                        auto: true,
                        speed: 1000,
                        pager: false
                      });
                    });
                    setBody();
                  }
                  else{
                    $('#mhaDaoBar').html(data.dao_bar_html);
                    setBody();
                  }
                }
                else{
                  $('#mhaDaoBar').html('');
                }
              },data.delay_time)
            })
            .fail(function() {
              console.log('error');
            })
            .always(function() {
              console.log('complete');
            });
          });
          $(document).on('click', '#rmvMhaDaoBar', function(event) {
            $('#mhaDaoBar').html('');
            $('body').css({'padding-top':'0px'});
          });
          
          $(document).on('click', '#mhaDaoBarSubscribe', function(event) {
            mha_email = $('#mhaDaoBarEmail').val();
            var mha_emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if(mha_emailReg.test( mha_email ) && mha_email){
              $.ajax({
                url: 'https://dev-masterapp.hulkapps.com/dao_bar/frontend/subscribe_dao_bar',
                type: 'GET',
                data: {shop_id: window.masterapp.store_id,email: mha_email,country: country}
              })
              .done(function(data) {
                console.log('subscribed data------>',data)
                if (data.dao_bar_html) {
                  $('#mhaDaoBarInner').html(data.dao_bar_html)
                }
                else{
                  $('#mhaDaoBar').html('');
                }
              })
              .fail(function() {
                console.log('error');
              })
              .always(function() {
                console.log('complete');
              });
            }else{
              $('#mhaDaoBarEmail').css('border','1px solid red');
            }
          });
          function setBody(){
            if(barPosition.indexOf('top') !== -1){
              setTimeout(function(){
                console.log($('#mhaDaoBar ul').height(),$('#mhaDaoBar li:first').outerHeight())
                bodyPadding = $('#mhaDaoBar li:first').outerHeight();
                if(bodyPadding){}else{
                  bodyPadding = $('#mhaDaoBar div').outerHeight();
                }
                $('body').css({'position':'relative','padding-top':bodyPadding});
              },100);
            }else{
              $('body').css({'position':'relative'});
            }
          }
          function mhaTimer(startDate) {
            console.log('testtttttt')
            var labels = ['days', 'hours', 'minutes', 'seconds'],
            nextYear = startDate,
            template = _.template($('#mhaDaoTimerTemplate').html()),
            currDate = '00:00:00:00:00',
            nextDate = '00:00:00:00:00',
            parser = /([0-9]{2})/gi,
            $example = $('#mhaDaoTimer');
            // Parse countdown string to an object
            function strfobj(str) {
              var parsed = str.match(parser),
                obj = {};
              labels.forEach(function(label, i) {
                obj[label] = parsed[i]
              });
              return obj;
            }
            // Return the time components that diffs
            function diff(obj1, obj2) {
              var diff = [];
              labels.forEach(function(key) {
                if (obj1[key] !== obj2[key]) {
                  diff.push(key);
                }
              });
              return diff;
            }
            // Build the layout
            var initData = strfobj(currDate);
            labels.forEach(function(label, i) {
              $example.append(template({
                curr: initData[label],
                next: initData[label],
                label: label
              }));
            });
            // Starts the countdown
            $example.countdown(nextYear, function(event) {
              var newDate = event.strftime('%D:%H:%M:%S'),
                data;
              if (newDate !== nextDate) {
                currDate = nextDate;
                nextDate = newDate;
                // Setup the data
                data = {
                  'curr': strfobj(currDate),
                  'next': strfobj(nextDate)
                };
                // Apply the new values to each node that changed
                diff(data.curr, data.next).forEach(function(label) {
                  var selector = '.%s'.replace(/%s/, label),
                      $node = $example.find(selector);
                  // Update the node
                  $node.removeClass('flip');
                  $node.find('.curr').text(data.curr[label]);
                  $node.find('.next').text(data.next[label]);
                  // Wait for a repaint to then flip
                  _.delay(function($node) {
                    $node.addClass('flip');
                  }, 50, $node);
                });
              }
            });
          };
          $(document).on('click','.display-text',function(){
            if(window.outerWidth < 768){
              $('.display-form').slideToggle();
              $('.display-text').toggleClass('mobile-text');
            }
          })
        